const CLIENTS = [
    { name: "Tanishq", category: "Jewellery", img: "/assets/clients/c01.png" },
    { name: "Ethos", category: "Watches", img: "/assets/clients/c02.png" },
    { name: "Allen Solly", category: "Fashion", img: "/assets/clients/c03.png" },
    { name: "Roseate Hotels & Resorts", category: "Hospitality", img: "/assets/clients/c04.png" },
    { name: "Bird Flight Services", category: "Aviation", img: "/assets/clients/c05.png" },
    { name: "Planet Fashion", category: "Fashion", img: "/assets/clients/c06.png" },
    { name: "Coverstory", category: "Fashion", img: "/assets/clients/c07.png" },
    { name: "Hitz", category: "Footwear", img: "/assets/clients/c08.png" },
    { name: "Reebok", category: "Sportswear", img: "/assets/clients/c09.png" },
    { name: "Van Heusen", category: "Fashion", img: "/assets/clients/c10.png" },
    { name: "Blackberrys", category: "Fashion", img: "/assets/clients/c11.png" },
    { name: "Louis Philippe", category: "Fashion", img: "/assets/clients/c12.png" },
    { name: "Richemont", category: "Luxury", img: "/assets/clients/c13.png" },
    { name: "American Eagle", category: "Fashion", img: "/assets/clients/c14.png" },
    { name: "Rolex", category: "Watches", img: "/assets/clients/c15.png" },
    { name: "ExecuJet Aviation Group", category: "Aviation", img: "/assets/clients/c16.png" },
    { name: "GS Mart", category: "Retail", img: "/assets/clients/c17.png" },
    { name: "Carrier", category: "Electronics", img: "/assets/clients/c18.png" },
    { name: "Pawfect", category: "Pet Care", img: "/assets/clients/c19.png" },
    { name: "De Beers Forevermark", category: "Jewellery", img: "/assets/clients/c20.png" },
    { name: "Reliance Industries", category: "Conglomerate", img: "/assets/clients/c21.png" },
    { name: "Kiehl's", category: "Beauty", img: "/assets/clients/c22.png" },
    { name: "Mr. Firefly Pizzeria", category: "F&B", img: "/assets/clients/c23.png" },
    { name: "Safety First", category: "Industrial", img: "/assets/clients/c24.png" },
    { name: "Taurian MPS", category: "Technology", img: "/assets/clients/c25.png" },
    { name: "SOMO", category: "Artisanal Bakery", img: "/assets/clients/c26.png" },
    { name: "Geonix", category: "Technology", img: "/assets/clients/c27.png" },
    { name: "Being Human", category: "Fashion", img: "/assets/clients/c28.png" },
    { name: "Balmain Swiss Watches", category: "Watches", img: "/assets/clients/c29.png" },
    { name: "Iskate by Roseate", category: "Hospitality", img: "/assets/clients/c30.png" },
    { name: "Bell & Ross", category: "Watches", img: "/assets/clients/c31.png" },
    { name: "Envision Projects", category: "Infrastructure", img: "/assets/clients/c32.png" },
    { name: "Nykaa", category: "Beauty", img: "/assets/clients/nykaa.svg" },
];

export const MARQUEE_NAMES = [
    "Tanishq", "Rolex", "Louis Philippe", "Reebok", "Kiehl's", "Reliance",
    "Blackberrys", "Being Human", "Van Heusen", "Ethos", "Carrier", "Balmain",
];

export const FEATURED_LOGOS = [0, 14, 11, 32, 1, 20, 21, 27].map((i) => CLIENTS[i]);

export default CLIENTS;
